import Icon from "./icon";
import IconGift from "./icons/icon-gift";
import styles from "./promo-label.module.scss";

type Props = {
  text: string;
};

export default function PromoLabel(props: Props) {
  return (
    <div className={styles.freeLabel}>
      <span>{props.text}</span>
      <Icon icon={IconGift} />
    </div>
  );
}
